module.exports = __webpack_public_path__ + "img/local_map.c0251b5e.jpeg";